const DynamicRenamingExportConfig = {
    Pim: 'pim',
    WebsiteUrl: 'websiteUrl',
} as const

export type DynamicRenamingExportConfigValue =
    typeof DynamicRenamingExportConfig[keyof typeof DynamicRenamingExportConfig]

export default DynamicRenamingExportConfig
